import {mainMenu} from "./configs/mainMenu";

export const menu = {
  "mainMenu": mainMenu,
  "mobileMenu": mainMenu
}